'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to add a "loading..." layer div on top of some existing content.
 * The attribute's value must be a boolean expression. When the expression
 * evaluates to true, then the "loading..." layer will be added around the
 * content, otherwise it will be removed again.
 *
 * Usage:
 *
 * <div loading-container="boolean expression to watch">
 *     <!-- content to enable/disable -->
 * </div>
 *
 * For example when used with ngTable, and you have the tableParams in your
 * current controller scope, you could use:
 *
 * <div loading-container="tableParams.settings().$loading">
 *     <table ng-table="...">
 * </div>
 */
    .directive('loadingContainer', function () {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var loadingLayer = angular.element('<div class="loading"></div>');
                element.append(loadingLayer);
                element.addClass('loading-container');
                scope.$watch(attrs.loadingContainer, function (value) {
                    loadingLayer.toggleClass('ng-hide', !value);
                });
            }
        };
    });